import { AppRoutes } from './routes.js';

/**
 * Application root. Providers (router, auth, toasts) are set up in main.tsx; App
 * simply renders the role-aware route tree.
 */
export function App() {
  return <AppRoutes />;
}
